var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"field-required",attrs:{"title":_vm.$t('validation.required.short')}},[_vm._v("*")])
}
var staticRenderFns = []

export { render, staticRenderFns }